import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import { first, isEmpty } from 'lodash';
import { FaGoogle, FaFacebookF } from 'react-icons/fa';

import routeConfiguration from '../../routeConfiguration';
import { camelize } from '../../util/string';
import { pathByRouteName } from '../../util/routes';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import config from '../../config';
import { ERROR_CODE_EMAIL_PASSWORD_SIGNIN, propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import {
  isEmailPasswordExistError,
  isInvalidOtpError,
  isSignupEmailTakenError,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';

import {
  login,
  authenticationInProgress,
  signup,
  signupWithIdp,
  customSignup,
} from '../../ducks/Auth.duck';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  addOrUpdateWorkerExtraDetails,
  fetchCurrentUser,
  sendVerificationEmail,
} from '../../ducks/user.duck';
import { manageDisableScrolling } from '../../ducks/UI.duck';

import {
  Page,
  NamedLink,
  NamedRedirect,
  LinkTabNavHorizontal,
  IconEmailSent,
  InlineTextButton,
  SocialLoginButton,
  IconClose,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Modal,
} from '../../components';
import { ConfirmSignupForm, LoginForm, SignupForm } from '../../forms';

import { TopbarContainer } from '../../containers';

import {
  TOS_ASSET_NAME,
  TermsOfServiceContent,
} from '../../containers/TermsOfServicePage/TermsOfServicePage';

import css from './AuthenticationPage.module.css';
import { FacebookLogo, GoogleLogo } from './socialLoginLogos';
import {
  COMPANY_SIGN_UP,
  CONFIRM,
  customIdsKeyName,
  defaultPhonecodeCountry,
  LOGIN,
  SIGN_UP,
  WORKER_SIGN_UP,
  USER_TYPE,
  workerAllowedOptions,
  drivingLicenseOptions,
  age16PlusOptions,
} from '../../marketplace-custom-config';
import { storeData } from '../../util/sessionStorageHelper';
import { parse } from '../../util/urlHelpers';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

export class AuthenticationPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tosModalOpen: false,
      authError: Cookies.get('st-autherror')
        ? JSON.parse(Cookies.get('st-autherror').replace('j:', ''))
        : null,
      authInfo: Cookies.get('st-authinfo')
        ? JSON.parse(Cookies.get('st-authinfo').replace('j:', ''))
        : null,
      affiliateCodeValid: null, // null = not checked, true = valid, false = invalid
    };
  }

  componentDidMount() {
    Cookies.remove('st-autherror');

    const affiliatedCode = this.props.params?.affiliatedCode;
    if (affiliatedCode) {
      axios
        .get(`${apiBaseUrl()}/api/v2/affiliate/codes/${affiliatedCode}`, { withCredentials: true })
        .then(res => this.setState({ affiliateCodeValid: !!res.data?.valid }))
        .catch(() => this.setState({ affiliateCodeValid: false }));
    }
  }

  isValidParamsForSocialLogin = params => {
    const { email = '', token = '' } = params || {};
    return !!email && !!token && token.length === 64;
  };

  render() {
    const affiliatedCode = this.props.params?.affiliatedCode;
    const { affiliateCodeValid } = this.state;

    // Invalid affiliate code → redirect to normal company signup
    if (affiliatedCode && affiliateCodeValid === false) {
      return <Redirect to="/signup-company" />;
    }

    // Still validating — render nothing to avoid flash of signup form
    if (affiliatedCode && affiliateCodeValid === null) {
      return null;
    }

    const {
      authInProgress,
      currentUser,
      signupUser,
      intl,
      isAuthenticated,
      location,
      loginError,
      scrollingDisabled,
      signupError,
      submitLogin,
      submitSignup,
      submitCustomSignup,
      confirmError,
      submitSingupWithIdp,
      tab,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      onResendVerificationEmail,
      onManageDisableScrolling,
      tosAssetsData,
      tosFetchInProgress,
      tosFetchError,
      history,
      userNativeLang,
      onFetchCurrentUser,
      workerExtraDetailsAddOrUpdateInProgress,
      workerExtraDetailsAddOrUpdateError,
      onAddOrUpdateWorkerExtraDetails,
      onUpdateProfile,
    } = this.props;

    const isConfirm = tab === 'confirm';
    const isLogin = tab === 'login';
    // console.log(1234, isConfirm, isLogin, tab);
    const isBusinessSignup = tab === COMPANY_SIGN_UP;
    const isWorkerSignup = tab === WORKER_SIGN_UP;
    const locationFrom = location.state && location.state.from ? location.state.from : null;
    const authinfoFrom =
      this.state.authInfo && this.state.authInfo.from ? this.state.authInfo.from : null;
    const from = locationFrom ? locationFrom : authinfoFrom ? authinfoFrom : null;

    const params = parse(location.search || '');
    const isValidSocailParams = this.isValidParamsForSocialLogin(params);
    const { e: queryErr } = params || {};

    const loginInitialValueMaybe = isValidSocailParams
      ? { email: params.email, token: params.token, isOtpValidated: true }
      : {};

    const user = ensureCurrentUser(currentUser);
    const currentUserLoaded = !!user.id;
    const currentSignupUser = ensureUser(signupUser);
    const currentSignupUserLoaded = !!currentSignupUser.id;

    const workerInitialValues = {
      workerAllowed: workerAllowedOptions.yes.value,
      drivingLicense: drivingLicenseOptions.yes.value,
      age16Plus: age16PlusOptions.yes.value,
    };

    // Email verification is now handled by EmailVerificationBar in TopbarDesktop
    // We no longer show the email verification modal here
    const showEmailVerification = false;
    // console.log(112211, currentUser);
    // Already authenticated, redirect away from auth page
    // console.log(
    //   4233,
    //   isAuthenticated,
    //   currentUser?.id?.uuid,
    //   !currentUser?.attributes?.profile?.publicData?.isProvider,
    //   currentUserLoaded,
    //   !showEmailVerification
    // );
    if (isAuthenticated && from) {
      return <Redirect to={from} />;
      // } else if (isAuthenticated && currentUserLoaded && !showEmailVerification) {
      //   return <NamedRedirect name="LandingPage" />;
    } else if (
      isAuthenticated &&
      currentUser?.id?.uuid &&
      currentUser?.attributes?.profile?.publicData?.isSuperAdmin
    ) {
      return <NamedRedirect name="AdminStaffPage" />;
    } else if (
      isAuthenticated &&
      currentUser?.id?.uuid &&
      currentUser?.attributes?.profile?.publicData?.isProvider
    ) {
      // return <NamedRedirect name="BusinessDashboardStaffPage" />;
      return <NamedRedirect name="ManageListingsPage" />;
    } else if (
      isAuthenticated &&
      currentUser?.id?.uuid &&
      !currentUser?.attributes?.profile?.publicData?.isProvider
    ) {
      // return <NamedRedirect name="SearchPage" />;
      return <NamedRedirect name="SearchPage" />;
    }

    const isEmailTakenError = isSignupEmailTakenError(signupError);
    const isInvalidOtpErr = isInvalidOtpError(loginError);
    const isInvalidOtpErrSignup = isInvalidOtpError(signupError);
    const isEmailPasswordExistErr =
      isEmailPasswordExistError(loginError) || queryErr === ERROR_CODE_EMAIL_PASSWORD_SIGNIN;
    // console.log(777, loginError, queryErr);
    const loginErrorMessage = (
      <div className={css.error}>
        {isInvalidOtpErr ? (
          <FormattedMessage id="AuthenticationPage.otpInvalid" />
        ) : isEmailPasswordExistErr ? (
          <FormattedMessage id="AuthenticationPage.emailPasswordError" />
        ) : (
          <FormattedMessage id="AuthenticationPage.loginFailed" />
        )}
      </div>
    );

    const signupErrorMessage = (
      <div className={css.error}>
        {isEmailTakenError ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    );

    const confirmErrorMessage = confirmError ? (
      <div className={css.error}>
        {isSignupEmailTakenError(confirmError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    ) : null;

    // eslint-disable-next-line no-confusing-arrow
    const errorMessage = (error, message) => (error ? message : null);
    const loginOrSignupError = isLogin
      ? errorMessage(loginError || queryErr === ERROR_CODE_EMAIL_PASSWORD_SIGNIN, loginErrorMessage)
      : errorMessage(signupError || workerExtraDetailsAddOrUpdateError, signupErrorMessage);
    // console.log(666, confirmError, loginError, isLogin, queryErr);

    const fromState = { state: from ? { from } : null };

    // const tabs = [
    //   {
    //     text: (
    //       <h1 className={css.tab}>
    //         <FormattedMessage id="AuthenticationPage.signupLinkText" />
    //       </h1>
    //     ),
    //     selected: !isLogin,
    //     linkProps: {
    //       name: 'SignupPage',
    //       to: fromState,
    //     },
    //   },
    //   {
    //     text: (
    //       <h1 className={css.tab}>
    //         <FormattedMessage id="AuthenticationPage.loginLinkText" />
    //       </h1>
    //     ),
    //     selected: isLogin,
    //     linkProps: {
    //       name: 'LoginPage',
    //       to: fromState,
    //     },
    //   },
    // ];

    const handleSubmitSignup = values => {
      const { fname, lname, ...rest } = values;
      const affiliatedCode = this.props.params?.affiliatedCode;
      const workerParams = { ...rest };
      const providerParams = { firstName: fname, lastName: lname, ...rest, ...(affiliatedCode ? { affiliatedCode } : {}) };
      return tab === WORKER_SIGN_UP ? submitCustomSignup(workerParams) : submitSignup(providerParams);
    };

    const handleSubmitConfirm = values => {
      const { idpToken, email, firstName, lastName, idpId } = this.state.authInfo;
      const { firstName: newFirstName, lastName: newLastName, ...rest } = values;

      // Pass email, fistName or lastName to Flex API only if user has edited them
      // sand they can't be fetched directly from idp provider (e.g. Facebook)

      const authParams = {
        email,
        ...(newFirstName !== firstName && { firstName: newFirstName }),
        ...(newLastName !== lastName && { lastName: newLastName }),
        displayName: `${newFirstName} ${newLastName}`,
      };

      // If the confirm form has any additional values, pass them forward as user's protected data
      // const protectedData = !isEmpty(rest) ? { ...rest } : null;

      submitSingupWithIdp({
        idpToken,
        idpId,
        ...authParams,
        ...(!isEmpty(rest) && { ...rest }),
      });
    };

    const getDefaultRoutes = (isBusinessSignup, isWorkerSignup) => {
      const routes = routeConfiguration();
      const baseUrl = apiBaseUrl();

      // Route where the user should be returned after authentication
      // This is used e.g. with EditListingPage and ListingPage
      const fromParam = from ? `from=${from}` : '';

      // Default route where user is returned after successfull authentication
      const defaultReturn = pathByRouteName('LandingPage', routes);
      const defaultReturnParam = defaultReturn ? `&defaultReturn=${defaultReturn}` : '';

      // Route for confirming user data before creating a new user
      const defaultConfirm = pathByRouteName('ConfirmPage', routes);
      const defaultConfirmParam = defaultConfirm ? `&defaultConfirm=${defaultConfirm}` : '';
      const type = `&type=${
        isBusinessSignup
          ? customIdsKeyName.business
          : isWorkerSignup
          ? customIdsKeyName.worker
          : customIdsKeyName.guest
      }`;

      return {
        baseUrl,
        fromParam,
        defaultReturnParam,
        defaultConfirmParam,
        type,
      };
    };
    const authWithFacebook = () => {
      const defaultRoutes = getDefaultRoutes(isBusinessSignup, isWorkerSignup);
      const { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam, type } = defaultRoutes;
      storeData(
        USER_TYPE,
        isBusinessSignup
          ? customIdsKeyName.business
          : isWorkerSignup
          ? customIdsKeyName.worker
          : customIdsKeyName.guest
      );
      window.location.href = `${baseUrl}/api/auth/facebook?${fromParam}${defaultReturnParam}${defaultConfirmParam}${type}`;
    };

    const authWithGoogle = () => {
      const defaultRoutes = getDefaultRoutes(isBusinessSignup, isWorkerSignup);
      const { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam, type } = defaultRoutes;
      storeData(
        USER_TYPE,
        isBusinessSignup
          ? customIdsKeyName.business
          : isWorkerSignup
          ? customIdsKeyName.worker
          : customIdsKeyName.guest
      );
      window.location.href = `${baseUrl}/api/auth/google?${fromParam}${defaultReturnParam}${defaultConfirmParam}${type}`;
    };

    const handleFacebookLogin = e => {
      e.preventDefault();
      e.stopPropagation();
      authWithFacebook();
    };

    const handleGoogleLogin = e => {
      e.preventDefault();
      e.stopPropagation();
      authWithGoogle();
    };

    const idp = this.state.authInfo
      ? this.state.authInfo.idpId.replace(/^./, str => str.toUpperCase())
      : null;

    // Form for confirming information frm IdP (e.g. Facebook)
    // before new user is created to Flex
    const confirmForm = (
      <div className={css.content}>
        <h1 className={css.signupWithIdpTitle}>
          <FormattedMessage id="AuthenticationPage.confirmSignupWithIdpTitle" values={{ idp }} />
        </h1>

        <p className={css.confirmInfoText}>
          <FormattedMessage id="AuthenticationPage.confirmSignupInfoText" />
        </p>

        <ConfirmSignupForm
          className={css.form}
          onSubmit={handleSubmitConfirm}
          inProgress={authInProgress}
          onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
          authInfo={this.state.authInfo}
          idp={idp}
          userNativeLang={userNativeLang}
          onManageDisableScrolling={onManageDisableScrolling}
          errorMessage={confirmErrorMessage}
          initialValues={{
            phoneNumber: defaultPhonecodeCountry,
            ...(this.state.authInfo?.userType === customIdsKeyName.worker
              ? workerInitialValues
              : {}),
          }}
          history={history}
          intl={intl}
          initialValuesForWorker={workerInitialValues}
        />
      </div>
    );

    // Social login buttons
    const showFacebookLogin = !!process.env.REACT_APP_FACEBOOK_APP_ID;
    const showGoogleLogin = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const showSocialLogins = showFacebookLogin || showGoogleLogin;

    const facebookButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithFacebook" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithFacebook" />
    );

    const googleButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithGoogle" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithGoogle" />
    );
    const socialLoginButtonsMaybe = showSocialLogins ? (
      <div className={css.idpButtons}>
        <div className={css.socialButtonsOr}>
          <span className={css.socialButtonsOrText}>
            <FormattedMessage id="AuthenticationPage.or" />
          </span>
        </div>
       <div className={css.soclBtnGrp}>
        {showGoogleLogin ? (
          <div className={css.socialButtonWrapper}>
            <SocialLoginButton onClick={handleGoogleLogin}>
              <span className={css.buttonIcon}>
                <FaGoogle />
              </span>
              {googleButtonText}
            </SocialLoginButton>
          </div>
        ) : null}

        {showFacebookLogin ? (
          <div className={css.socialButtonWrapper}>
            <SocialLoginButton onClick={handleFacebookLogin}>
              <span className={css.buttonIcon}>{<FaFacebookF />}</span>
              {facebookButtonText}
            </SocialLoginButton>
          </div>
        ) : null}
       </div>
      </div>
    ) : null;

    // Tabs for SignupForm and LoginForm
    const authenticationForms = (
      <div className={classNames(css.content, { [css.loginContent]: isLogin })}>
        {/*<LinkTabNavHorizontal className={css.tabs} tabs={tabs} />*/}
        {/*loginOrSignupError*/}

        {isLogin ? (
          <LoginForm
            className={css.loginForm}
            onSubmit={submitLogin}
            inProgress={authInProgress}
            loginError={loginOrSignupError}
            history={history}
            socialLoginButtonsMaybe={socialLoginButtonsMaybe}
            initialValues={loginInitialValueMaybe}
            loginStep={isValidSocailParams ? 1 : 0}
            isInvalidOtpError={isInvalidOtpErr}
            userNativeLang={userNativeLang}
            onManageDisableScrolling={onManageDisableScrolling}
          />
        ) : (
          <SignupForm
            className={css.signupForm}
            initialValues={{
              phoneNumber: defaultPhonecodeCountry,
              ...(tab === WORKER_SIGN_UP ? workerInitialValues : {}),
            }}
            onSubmit={handleSubmitSignup}
            inProgress={authInProgress || workerExtraDetailsAddOrUpdateInProgress}
            onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
            tab={tab}
            formId={tab}
            history={history}
            onManageDisableScrolling={onManageDisableScrolling}
            userNativeLang={userNativeLang}
            errorMessage={loginOrSignupError}
            isEmailTakenError={isEmailTakenError}
            currentUserLoaded={currentUserLoaded}
            currentUser={user}
            isAuthenticated={isAuthenticated}
            currentSignupUserLoaded={currentSignupUserLoaded}
            currentSignupUser={currentSignupUser}
            onFetchCurrentUser={onFetchCurrentUser}
            onAddOrUpdateWorkerExtraDetails={onAddOrUpdateWorkerExtraDetails}
            socialLoginButtonsMaybe={socialLoginButtonsMaybe}
            onUpdateProfile={onUpdateProfile}
          />
        )}

        {/*socialLoginButtonsMaybe*/}
      </div>
    );

    const formContent = isConfirm ? confirmForm : authenticationForms;

    const name = user.attributes.profile.firstName;
    const email = <span className={css.email}>{user.attributes.email}</span>;

    const resendEmailLink = (
      <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
        <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
      </InlineTextButton>
    );
    const fixEmailLink = (
      <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
        <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
      </NamedLink>
    );

    const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
      sendVerificationEmailError
    )
      ? 'AuthenticationPage.resendFailedTooManyRequests'
      : 'AuthenticationPage.resendFailed';
    const resendErrorMessage = sendVerificationEmailError ? (
      <p className={css.error}>
        <FormattedMessage id={resendErrorTranslationId} />
      </p>
    ) : null;

    const emailVerificationContent = (
      <div className={css.content}>
        <NamedLink className={css.verifyClose} name="ProfileSettingsPage">
          <span className={css.closeText}>
            <FormattedMessage id="AuthenticationPage.verifyEmailClose" />
          </span>
          <IconClose rootClassName={css.closeIcon} />
        </NamedLink>
        <IconEmailSent className={css.modalIcon} />
        <h1 className={css.modalTitle}>
          <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
        </h1>
        <p className={css.modalMessage}>
          <FormattedMessage id="AuthenticationPage.verifyEmailText" values={{ email }} />
        </p>
        {resendErrorMessage}

        <div className={css.bottomWrapper}>
          <p className={css.modalHelperText}>
            {sendVerificationEmailInProgress ? (
              <FormattedMessage id="AuthenticationPage.sendingEmail" />
            ) : (
              <FormattedMessage id="AuthenticationPage.resendEmail" values={{ resendEmailLink }} />
            )}
          </p>
          <p className={css.modalHelperText}>
            <FormattedMessage id="AuthenticationPage.fixEmail" values={{ fixEmailLink }} />
          </p>
        </div>
      </div>
    );

    const siteTitle = config.siteTitle;
    const schemaTitle = isLogin
      ? intl.formatMessage({ id: 'AuthenticationPage.schemaTitleLogin' }, { siteTitle })
      : intl.formatMessage({ id: 'AuthenticationPage.schemaTitleSignup' }, { siteTitle });

    const topbarClasses = classNames({
      [css.hideOnMobile]: showEmailVerification,
    });

    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: schemaTitle,
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer className={topbarClasses} />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain
            className={classNames(css.layoutWrapperMain, { [css.loginLayoutWrapperMain]: isLogin })}
          >
            <div className={classNames(css.root, { [css.loginRoot]: isLogin })}>
              {showEmailVerification ? emailVerificationContent : formContent}
            </div>
            <Modal
              id="AuthenticationPage.tos"
              isOpen={this.state.tosModalOpen}
              onClose={() => this.setState({ tosModalOpen: false })}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.termsWrapper}>
                <TermsOfServiceContent
                  inProgress={tosFetchInProgress}
                  error={tosFetchError}
                  data={tosAssetsData?.[camelize(TOS_ASSET_NAME)]?.data}
                />
              </div>
            </Modal>
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

AuthenticationPageComponent.defaultProps = {
  currentUser: null,
  loginError: null,
  signupError: null,
  confirmError: null,
  tab: 'signup',
  sendVerificationEmailError: null,
  showSocialLoginsForTests: false,
  tosAssetsData: null,
  tosFetchInProgress: false,
  tosFetchError: null,
};

const { bool, func, object, oneOf, shape } = PropTypes;

AuthenticationPageComponent.propTypes = {
  authInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  isAuthenticated: bool.isRequired,
  loginError: propTypes.error,
  scrollingDisabled: bool.isRequired,
  signupError: propTypes.error,
  confirmError: propTypes.error,

  submitLogin: func.isRequired,
  submitSignup: func.isRequired,
  tab: oneOf([LOGIN, SIGN_UP, CONFIRM, COMPANY_SIGN_UP, WORKER_SIGN_UP]),

  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  onResendVerificationEmail: func.isRequired,
  onManageDisableScrolling: func.isRequired,

  // to fetch terms-of-service page asset
  // which is shown in modal
  tosAssetsData: object,
  tosFetchInProgress: bool,
  tosFetchError: propTypes.error,

  // from withRouter
  location: shape({ state: object }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated, loginError, signupError, confirmError, signupUser } = state.Auth;
  const {
    currentUser,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    workerExtraDetailsAddOrUpdateInProgress,
    workerExtraDetailsAddOrUpdateError,
  } = state.user;
  const { pageAssetsData: tosAssetsData, inProgress: tosFetchInProgress, error: tosFetchError } =
    state.hostedAssets || {};
  const { userNativeLang } = state.UI;

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    scrollingDisabled: isScrollingDisabled(state),
    signupError,
    confirmError,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    tosAssetsData,
    tosFetchInProgress,
    tosFetchError,
    userNativeLang,
    signupUser,
    workerExtraDetailsAddOrUpdateInProgress,
    workerExtraDetailsAddOrUpdateError,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: params => dispatch(login(params)),
  submitSignup: params => dispatch(signup(params)),
  submitCustomSignup: params => dispatch(customSignup(params)),
  submitSingupWithIdp: params => dispatch(signupWithIdp(params)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onAddOrUpdateWorkerExtraDetails: params => dispatch(addOrUpdateWorkerExtraDetails(params)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AuthenticationPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(AuthenticationPageComponent);

export default AuthenticationPage;
